module.exports = __webpack_public_path__ + "static/assets/a13d26f1d835911a1fbd9b9285ff5166.svg";